<template lang="pug">
  div
    v-row.pa-4(no-gutters align="center")
      v-col.pr-2
        v-text-field(v-model="search" :placeholder='searchPlaceholder' hide-details dense outlined height="40" background-color="basic200" clearable :disabled="isFetching")
          template(v-slot:append)
            eva-icon(v-if="!search" name="search-outline" :fill="$vuetify.theme.themes[$theme].basic600" )
      v-col.py-2.shrink
        v-btn.elevation-0.pa-0(color="transparent" small icon @click="openPayoutFilter = true" :disabled="isFetching")
          eva-icon(name="options-2-outline" :fill="$vuetify.theme.themes[$theme].primary400" height="23" style="margin-top: 2px")
    .modal
      payout-filter(v-if="openPayoutFilter" :open.sync="openPayoutFilter" :filters="filters" :companyTiers="companyTiers" @updateFilter="$emit('updateFilter', $event)")
</template>

<script>
import PayoutFilter from '@/components/resellers/payouts/PayoutFilter.vue'

export default {
  name: 'PayoutTop',
  components: { PayoutFilter },
  props: {
    company: {
      type: Object,
      default: () => {
        return {}
      }
    },
    searchText: {
      type: String,
      default: ''
    },
    isFetching: {
      type: Boolean
    },
     filters: {
      type: Object,
      required: true
    },
    companyTiers: {
      type: Array,
      required: true
    },
  },
  data: () => ({
    openPayoutFilter: false,
  }),
  computed: {
    search: {
      get() {
        return this.searchText 
      },
      set(val) {
        this.$emit('update:searchText', val)
      }
    },
    searchPlaceholder() {
      switch (this.$route.hash) {
        case '#toProcess':
          return 'Search commissions'

        case '#processing':
          return 'Search payouts'

        case '#completed':
          return 'Search payouts'
      
        default:
          return null
      }
    }
  },
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>